import React from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {cilX} from '@coreui/icons';
import styles from './Agronomy.module.css';
import {hideBuyFertilizerModal} from './agronomy-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const BuyFertilizerModal = () => {

  const dispatch = useDispatch();

  const buyFertilizerModalIsVisible = useSelector(state => state.agronomy.buyFertilizerModalIsVisible);

  return (
    <CModal
      fullscreen
      alignment='center'
      scrollable 
      visible={buyFertilizerModalIsVisible}>
      <CModalHeader closeButton={false}>
        <CModalTitle className={styles.buyFertilizerModalTitle}>Buy Fertilizer</CModalTitle>
        <CButton className={styles.modalCloseButton} onClick={() => dispatch(hideBuyFertilizerModal())}>
          <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
        </CButton>
      </CModalHeader>
      <CModalBody className={styles.modalBody}>
        <iframe src='https://forms.office.com/r/yjVmNeCmqC' title='Buy Fertilizer' className={styles.modalIframe} />
      </CModalBody>
    </CModal>
  );
}

export default BuyFertilizerModal;